<template>
  <button class="select-area" @click="onClick">
    <span class="select-area__icon"></span>
    <div class="select-area__text">
      {{ label }}
    </div>
  </button>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    }
  },
  methods: {
    onClick() {
      this.$emit('click-button')
    }
  }
}
</script>

<style lang="scss" scoped>
.select-area {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-size: 1.6rem;
  line-height: 1.6;
  cursor: pointer;
  text-decoration: none;
  color: $link;
  background-color: $white;
  width: 100%;
  border-top: 1px $gray-2 solid;
  border-bottom: 1px $gray-2 solid;

  @media (hover: hover) {
    &:hover {
      opacity: 0.7;
    }
  }

  &__icon {
    background-image: url('../../../../../images/icons/link-plus-circle.svg');
    background-repeat: no-repeat;
    background-color: $white;
    object-fit: contain;
    width: 20px;
    height: 20px;
  }

  &__text {
    padding: 24px 0;
  }
}
</style>
